import React from "react";

export default function CommuniCaptureHelp() {
  return (
    <div className="bg-gray-900 text-gray-200 rounded-xl p-4 md:p-6 shadow-lg">
      <h3 className="text-base md:text-lg font-semibold mb-3 text-blue-400">
        Help & Guide
      </h3>

      <ul className="list-disc pl-5 space-y-2 text-sm md:text-base leading-relaxed">
        <li>Use the WhatsApp tab to analyze chat conversations.</li>
        <li>Use the Email tab to analyze copy-pasted email text.</li>
        <li>
          The “List” section shows your previously saved analysis records from
          TCloud.
        </li>
        <li>
          This module supports name masking, AI processing, and AI/Browser TTS
          integration.
        </li>
      </ul>
    </div>
  );
}
